import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import './markdown.css';

export const MarkdownToReact: FC<{ desc: string }> = ({ desc }) => (
  <div className="markdown-container">
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{desc}</ReactMarkdown>
  </div>
);
